import { render, staticRenderFns } from "./ProductsAccessedTab.vue?vue&type=template&id=0e06fbb6"
import script from "./ProductsAccessedTab.vue?vue&type=script&lang=js"
export * from "./ProductsAccessedTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports